import PropTypes from 'prop-types';
import { iterableOf } from 'react-immutable-proptypes';
import { ABILITIES } from 'app/constants/enums/Ability';
import * as Schema from 'app/constants/schemas';
import sectionTypes from 'app/constants/schemas/sectionTypes';
import { isValidElementType } from 'react-is';

const instanceOfType = (type) => PropTypes.instanceOf(type);

const isComponentTypeValidator = (isRequired, props, propName) => {
  const value = props[propName];
  const isComponent = isValidElementType(value);
  if (
    isRequired ?
      !isComponent :
      value && !isComponent
  ) {
    return new Error(`Expected prop '${propName}' to be a valid React component type`);
  } else {
    return undefined;
  }
};

export const componentType = (props, propName) => isComponentTypeValidator(false, props, propName);
componentType.isRequired = (props, propName) => isComponentTypeValidator(true, props, propName);

export const refType = PropTypes.oneOfType([
  PropTypes.func,   // callback ref
  PropTypes.shape({ // React.createRef() object
    current: PropTypes.any,
  }),
]);

export const arrayOfAbilities = PropTypes.oneOfType([
  PropTypes.arrayOf(PropTypes.oneOf([...ABILITIES])),
  iterableOf(PropTypes.oneOf([...ABILITIES])),
]);

export const anyEntityType = PropTypes.oneOf([].concat(...Object.values(Schema)));

const entityTypes = [...Object.values(Schema)].filter(type =>
  // Filter out external association definitions from list of entity types.
  typeof type === 'function',
);
export const anyEntity = PropTypes.oneOfType(entityTypes.map(instanceOfType));

export const sectionEntity = PropTypes.oneOfType(sectionTypes.map(instanceOfType));

const quizTypes = [
  Schema.Question,
  Schema.ParagraphSentenceQuiz,
  Schema.DialogSentenceQuiz,
];

export const quizEntity = PropTypes.oneOfType(quizTypes.map(instanceOfType));
export const quizSchemaType = PropTypes.oneOf(quizTypes);

export const mediaParentType = PropTypes.oneOf([Schema.MediaSection, Schema.MediaGroup]);

export const locationShape = PropTypes.shape({
  hash: PropTypes.string.isRequired,
  key: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  search: PropTypes.string.isRequired,
});

export const historyShape = PropTypes.shape({
  addNavigationBlocker: PropTypes.func.isRequired,
  createHref: PropTypes.func.isRequired,
  listen: PropTypes.func.isRequired,
  location: locationShape.isRequired,
  push: PropTypes.func.isRequired,
  replace: PropTypes.func.isRequired,
  setWantsReloadOnNavigate: PropTypes.func.isRequired,
});
